<div class="root">
    <div class="flex justify-end">
        <button mat-icon-button (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
        @if (dirty$ | async) {
            <div>
                DIRTY
            </div>
        }
    </div>
    @if(asset) {
        <div class="flex column content">
            <div class="flex row top">
                <img [src]="asset.thumbnail" width="128" />
                <div class="flex column justify-center name">
                    @if (user && user.id === asset.author.id) {
                        <form [formGroup]="form">
                            <mat-form-field appearance="outline">
                                <mat-label>Name</mat-label>
                                <input matInput formControlName="name" />
                            </mat-form-field>
                        </form>
                    } @else {
                        <h1>{{asset.name}}</h1>
                    }
                </div>
            </div>
            <div class="flex column info-table">
                <table class="flex column">
                    <tr>
                        <th>Author</th>
                        <td>{{asset.author.name}}</td>
                    </tr>
                    <tr>
                        <th>Created</th>
                        <td>{{asset.created | date}}</td>
                    </tr>
                    <tr>
                        <th>Description</th>
                        <td>
                            @if (user && user.id === asset.author.id) {
                                <form [formGroup]="form">
                                    <frog-markdown-textarea formControlName="description" appearance="outlined"></frog-markdown-textarea>
                                </form>
                            } @else {
                                <div [innerHTML]="asset.description | marked"></div>
                            }
                        </td>
                    </tr>
                </table>
                <frog-tag-inspector [asset]="asset"></frog-tag-inspector>
            </div>
        </div>
    }
</div>
